import React from "react";
import styled from "styled-components";

const Link = styled.a`
    color: #3b7433;
    text-decoration: underline;
    cursor: pointer;
`;

export const WebLink = ({idea}) => {
    const value = idea.webLink ? <Link target="_blank" href={idea.webLink}>{idea.webLink}</Link> : "\u2014";
    return <div className="t-web-link">{value}</div>;
};
